// components/ModalWrapper.js
"use client";

import Modal from "react-modal";

export default function ModalWrapper({
  isOpen,
  onRequestClose: onClose,
  children,
  style,
  label,
  contentLabel,
}) {
  // useEffect(() => {
  //   Modal.setAppElement("#__next"); // required for accessibility
  // }, []);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={style}
      contentLabel={label || contentLabel || "Modal"}
    >
      {children}
    </Modal>
  );
}
